var React = require('react');

function CommentAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z","className":"fa-secondary","key":1})]);
}

CommentAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CommentAlt;

CommentAlt.default = CommentAlt;
